import { SxProps, Theme } from "@mui/material";

type TSxArrayItem = Extract<SxProps<Theme>, ReadonlyArray<unknown>>[number];

export const toSxArray = (sx: SxProps<Theme> | undefined): readonly TSxArrayItem[] => {
    if (!sx) {
        return [];
    }

    return (Array.isArray(sx) ? sx : [sx]) as readonly TSxArrayItem[];
};
